import { SET_MESSAGES_NO_REPLY, SET_REPLY_MODAL_STATUS } from "../actionType";

const setReplyModalStatus = (data) => {
  return {
    type: SET_REPLY_MODAL_STATUS,
    payload: data,
  };
};

const setMessagesNoReplyData = (data) => {
  return {
    type: SET_MESSAGES_NO_REPLY,
    payload: data,
  };
};

export { setMessagesNoReplyData, setReplyModalStatus };
